// Auth pages
import Authenticate from './auth/authenticate'
import SignIn from './auth/sign-in'
import SignUp from './auth/sign-up'
import Splash from './auth/splash'
import ChangeInformation from './auth/change-information'
import OtpCode from './auth/otp-code'
import SettingDB from './auth/setting-db'

// Errors pages
import Error403 from './errors/403'
import Error404 from './errors/404'

// Workspace pages
import Projects from './admin/projects'
import Events from './admin/events'
import Members from './admin/settings/members'
import Information from './admin/settings/information'
import EmailSetting from './admin/settings/email-setting'
import ImportExport from './admin/settings/import-export'

// Project pages
import ProjectSecrets from './admin/projects/secrets'
import ProjectEnvironments from './admin/projects/environments'
import ProjectLeakedSecrets from './admin/projects/leaked-secrets'
import ProjectAccessKey from './admin/projects/access-key'
import ProjectAccessLog from './admin/projects/access-log'
import ProjectMembers from './admin/projects/members'
import ProjectInformation from './admin/projects/information'

// Account pages
import AccountDetails from './admin/account/details'
import AccountChangePassword from './admin/account/change-password'
import Account2FA from './admin/account/2fa'
import AccountUpdateEncryption from './admin/account/encryption'

// API Error page
import AdminErrorPage from './admin/errors'

export default {
  // Auth pages
  Authenticate,
  SignIn,
  SignUp,
  Splash,
  ChangeInformation,
  OtpCode,
  SettingDB,

  Error403,
  Error404,

  Projects,
  Events,
  Members,
  Information,
  EmailSetting,
  ImportExport,

  ProjectSecrets,
  ProjectEnvironments,
  ProjectLeakedSecrets,
  ProjectAccessKey,
  ProjectAccessLog,
  ProjectMembers,
  ProjectInformation,

  AccountDetails,
  AccountChangePassword,
  Account2FA,
  AccountUpdateEncryption,

  AdminErrorPage
}